declare var __KAPSEA__PLUGIN__SERVER__: {
  ajaxURL: string;
  cookie: {
    handle: string;
    expiry: number;
    secure: boolean;
  };
};
export const { cookie, ajaxURL } = __KAPSEA__PLUGIN__SERVER__;
